/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TokenTenantModel {
    getFixupPrototypeFunction() { return TokenTenantModel.fixupPrototype; }

    static newInstance(model: Partial<TokenTenantModel>): TokenTenantModel {
        let obj = Object.assign(new TokenTenantModel(), model);
        TokenTenantModel.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TokenTenantModel>): TokenTenantModel {
        if (!model) return null;
        return TokenTenantModel.newInstance(<TokenTenantModel> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TokenTenantModel) {
        if (!obj) return;

        models.TokenTenantModel.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TokenTenantModel): boolean {
        Object.setPrototypeOf(obj, TokenTenantModel.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Id of the tenant. This will be used for performing tenant level operations such as createPolicy, createScript, onboardCloudAccount and so on.
     */
    id: string;

    /**
     * Unique name of the tenant provided as input when creating.
     */
    name: string;

    /**
     * If user created under particular tenant it will be set to True or else False
     */
    master_tenant: boolean;

    /**
     * Roles
     */
    roles: any;

}
